import React from 'react';
import styled from 'styled-components';

// helpers
import { isMobile } from 'app/helpers/utils';

const Label = styled.span`
   font-weight: bold;
  ${isMobile && 'text-align:left;'};
`;

export default Label;
